export const customStyles = {
  overlay: {
    backgroundColor: "rgb(36, 36, 36, 0.96)",
    zIndex: 2,
  },
};